import { render } from "./BaseGrayButton.vue?vue&type=template&id=1dd5c0e2"
import script from "./BaseGrayButton.vue?vue&type=script&lang=js"
export * from "./BaseGrayButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__